import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { BsExclamation } from "react-icons/bs";
import { PiCaretRightBold } from "react-icons/pi";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";

import { GoogleMaps } from "../../../../../components/GoogleMaps";
import { selectStyle } from "../../../../../components/InputSelectAsync";
import { Loading } from "../../../../../components/Loading";
import { useQuery } from "../../../../../hooks/useQuery";
import { BrComerceApiService } from "../../../../../services/BrComerceApiService";
import store from "../../../../../store/store";
import { cnpjValidation } from "../../../../../utils/CnpjValidation";
import { cpfValidation } from "../../../../../utils/CpfValidation";
import Steps from "../../../components/Steps";
import styles from "./styles.module.scss";
import { FiTrash2 } from "react-icons/fi";
import debounce from "lodash.debounce";
import { Spinner } from "react-bootstrap";

const SendForm = ({ step, totalSteps, isReverseLogistics }) => {
  const history = useHistory();
  const query = useQuery();

  const api = new BrComerceApiService();

  const { auth } = store.getState();
  const { user } = auth;

  const [fieldsAreAbleToSubmit, setFieldsAreAbleToSubmit] = useState(false);
  const [buttonSubmitIsAble, setButtonSubmitIsAble] = useState(false);

  const [nameOK, setNameOK] = useState("vazio");
  const [nameError, setNameError] = useState("");
  const [name, setName] = useState("");

  const [cpfOK, setCpfOK] = useState("vazio");
  const [cpfError, setCpfError] = useState("");
  const [cpf, setCpf] = useState("");

  const [phoneOK, setPhoneOK] = useState("vazio");
  const [phoneError, setPhoneError] = useState("");
  const [phone, setPhone] = useState("");

  const [zipCodeOK, setZipCodeOK] = useState("vazio");
  const [zipCodeError, setZipCodeError] = useState("");
  const [zipCode, setZipCode] = useState("");

  const [addressOK, setAddressOK] = useState("vazio");
  const [addressError, setAddressError] = useState("");
  const [address, setAddress] = useState("");

  const [addressNumberOK, setAddressNumberOK] = useState("vazio");
  const [addressNumberError, setAddressNumberError] = useState("");
  const [addressNumber, setAddressNumber] = useState("");
  const [addressIsDisabled, setAddressIsDisabled] = useState(true);

  const [addressObsOK, setAddressObsOK] = useState("vazio");
  const [addressObsError, setAddressObsError] = useState("");
  const [addressObs, setAddressObs] = useState("");

  const [addressNeighborhoodOK, setAddressNeighborhoodOK] = useState("vazio");
  const [addressNeighborhoodError, setAddressNeighborhoodError] = useState("");
  const [addressNeighborhood, setAddressNeighborhood] = useState("");
  const [
    addressNeighborhoodIsDisabled,
    setAddressNeighborhoodIsDisabled
  ] = useState(true);

  const [uf, setUf] = useState("");
  const [ufStatus, setUfStatus] = useState("");

  const [city, setCity] = useState("");
  const [cityStatus, setCityStatus] = useState("");

  const [ufs, setUfs] = useState([]);
  const [cities, setCities] = useState([]);

  const [obsOK, setObsOK] = useState("vazio");
  const [obsError, setObsError] = useState("");
  const [obs, setObs] = useState("");

  const [sendLocation, setSendLocation] = useState({
    lat: 0,
    lng: 0
  });

  const [isFilledWithStorageData, setIsFilledWithStorageData] = useState(false);

  const [selectedSavedAddress, setSelectedSaveAddress] = useState([]);

  const [savedAddress, setSaveAddress] = useState([]);

  const [savedAddressOpts, setSaveAddressOpts] = useState();

  const [searching, setSearching] = useState(true);

  const [formState, setFormState] = useState("create");

  const [loading, setLoading] = useState(false);

  const [loadingAddresses, setLoadingAddresses] = useState(false);

  const getMapsInformation = async cep => {
    const newCep = cep.replace(/\D/g, "");
    const response = await axios
      .get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${newCep}&result_type=geometry&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
      )
      .catch(e => {
        console.error(e);
        return undefined;
      });
    return response;
  };

  const handleCepConsult = useCallback(async cep => {
    try {
      setLoading(true);
      let response = await api.makeHttpRequest({
        method: "POST",
        url: `addressbook/getAddress`,
        data: {
          zipCode: cep
        }
      });

      if (!response) {
        setZipCodeOK("notOk");
        setZipCodeError("CEP inválido.");

        setAddress("");
        setAddressOK("vazio");
        setAddressError("");

        setAddressNeighborhood("");
        setAddressNeighborhoodOK("vazio");
        setAddressNeighborhoodError("");

        setUf("");
        setUfStatus("");
        setCity("");
        setCityStatus("");

        throw new Error("Não foi possível encontrar o CEP digitado.");
      }

      setZipCodeOK("ok");
      setZipCodeError("");

      if (!response.logradouro || response.logradouro === "undefined") {
        setAddressIsDisabled(false);
        setAddressOK("vazio");
      } else {
        setAddress(response.logradouro);
        setAddressOK("ok");
        setAddressError("");
      }

      if (!response.bairro || response.bairro === "undefined") {
        setAddressNeighborhoodIsDisabled(false);
        setAddressNeighborhoodOK("vazio");
      } else {
        setAddressNeighborhood(response.bairro);
        setAddressNeighborhoodOK("ok");
        setAddressNeighborhoodError("");
      }

      setUf({
        value: response.uf,
        label: response.uf
      });
      setUfStatus("");
      setCity({
        value: response.localidade,
        label: response.localidade
      });
      setCityStatus("");
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "CEP não encontrado",
        text: "Por favor, verifique o CEP inserido."
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const handleValidationName = useCallback(value => {
    value.length < 2 ? setNameOK("notOk") : setNameOK("ok");
    if (value.length === 0) {
      setNameError("Campo obrigatório");
    } else if (value.length === 1) {
      setNameError("Nome deve ter pelo menos 2 caracteres");
    } else {
      setNameError("");
    }
  }, []);

  const getAddresses = useCallback(async value => {
    if (value?.length < 3) {
      return;
    }

    try {
      setLoadingAddresses(true)
      const response = await api.makeHttpRequest({
        method: "GET",
        url: `addressbook`,
        params: {
          page: 1,
          resultsPerPage: 60,
          text: value,
        }
      });
      if (response?.results?.length) {
        setSaveAddress([...response.results.filter(opt => !opt.recipient)]);
      }

    } catch (e) {
      console.log(e);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível carregar as informações."
      });
    } finally {
      setLoadingAddresses(false)
    }
  }, []);

  const debouncedGetAddresses = useMemo(
    () => debounce((value) => getAddresses(value), 450),
    [getAddresses]
  );

  const handleInputName = useCallback(
    e => {
      setFormState("create");
      setSearching(true);
      let value = e.currentTarget.value;
      setName(value);
      handleValidationName(value);
      debouncedGetAddresses(value);
    },
    [handleValidationName, debouncedGetAddresses]
  );

  const handleValidationCPF = value => {
    const validCPF = cpfValidation({
      cpf: value,
      emptyCpf: "Campo obrigatório",
      incorrectCpf: "CPF incorreto"
    });
    setCpfOK(validCPF.status);
    setCpfError(validCPF.message);
  };

  const handleValidationCNPJ = value => {
    const validCnpj = cnpjValidation({
      cnpj: value,
      emptyCnpj: "Campo obrigatório",
      incorrectCnpj: "CNPJ incorreto"
    });
    setCpfOK(validCnpj.status);
    setCpfError(validCnpj.message);
  };

  const handleInputCpf = useCallback(e => {
    let inputValue = e.currentTarget.value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
    const hasLetters = /[A-Z]/.test(inputValue);

    if (inputValue.length <= 11 && !hasLetters) {
      let masked = inputValue.replace(/(\d{3})(\d)/, "$1.$2");
      masked = masked.replace(/(\d{3})\.(\d{3})(\d)/, "$1.$2.$3");
      masked = masked.replace(/(\d{3})\.(\d{3})\.(\d{3})(\d{1,2})$/, "$1.$2.$3-$4");
      
      e.currentTarget.value = masked;
      handleValidationCPF(inputValue);
      setCpf(masked);
    } else {
      e.currentTarget.maxLength = 18;

      let masked = inputValue;
      masked = masked.replace(/^([A-Z0-9]{2})([A-Z0-9])/, "$1.$2");
      masked = masked.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, "$1.$2.$3");
      masked = masked.replace(/\.([A-Z0-9]{3})([A-Z0-9])/, ".$1/$2");
      masked = masked.replace(/([A-Z0-9]{4})([0-9]{1,2})$/, "$1-$2");
      
      e.currentTarget.value = masked;
      handleValidationCNPJ(inputValue);
      setCpf(masked);
    }
  }, []);

  const handleValidationPhone = value => {
    if (value.length > 0 && value.length < 14) {
      setPhoneError("Telefone incorreto");
      setPhoneOK("notOk");
    } else if (value.length === 0) {
      setPhoneError("");
      setPhoneOK("vazio");
    } else {
      setPhoneError("");
      setPhoneOK("ok");
    }
  };

  const handleInputPhone = useCallback(e => {
    e.currentTarget.maxLength = 15;
    let value = e.currentTarget.value;
    value = value.replace(/\D/g, "");

    if (value.length === 11) {
      value = value.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    } else if (value.length === 10) {
      value = value.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    }

    e.currentTarget.value = value;
    handleValidationPhone(value);
    setPhone(value);
  }, []);

  const handleValidationZipCode = useCallback(
    async (value, isASavedInfo = false) => {
      if (value.length === 0) {
        setZipCodeOK("notOk");
        setZipCodeError("Preenchimento obrigatório");
      } else if (value.length < 9) {
        setZipCodeOK("notOk");
        setZipCodeError("Preenchimento incorreto");
      } else {
        if (isASavedInfo) {
          setZipCodeOK("ok");
          setZipCodeError("");
        }

        // Não queremos manipular o CEP novamente,
        // se o CEP selecionado pertence a um endereço já salvo
        if (isASavedInfo === false) {
          const cep = value.substr(0, 5) + value.substr(6, 3);
          await handleCepConsult(cep);
        }
      }
    },
    [handleCepConsult]
  );

  const handleInputZipCode = useCallback(
    e => {
      e.currentTarget.maxLength = 9;
      let value = e.currentTarget.value;
      value = value.replace(/\D/g, "");
      value = value.replace(/^(\d{5})(\d{3})/, "$1-$2");

      handleValidationZipCode(value);
      e.currentTarget.value = value;
      setZipCode(value);
    },
    [handleValidationZipCode]
  );

  const handleValidationAddress = value => {
    value.length < 2 ? setAddressOK("notOk") : setAddressOK("ok");
    if (value.length === 0) {
      setAddressError("Campo obrigatório");
    } else if (value.length === 1) {
      setAddressError("Endereço deve ter pelo menos 2 caracteres");
    } else {
      setAddressError("");
    }
  };

  const handleInputAddress = useCallback(
    e => {
      if (addressIsDisabled) return;

      let value = e.currentTarget.value;
      setAddress(value);
      handleValidationAddress(value);
    },
    [addressIsDisabled]
  );

  const handleValidationAddressNumber = value => {
    if (value !== "") {
      setAddressNumberOK("ok");
    } else {
      setAddressNumberOK("vazio");
      setAddressNumberError("");
    }
  };

  const handleInputAddressNumber = useCallback(e => {
    let value = e.currentTarget.value;

    if (value !== "" && !Number(value)) {
      return;
    }

    setAddressNumber(value);
    handleValidationAddressNumber(value);
  }, []);

  const handleValidationAddressObs = value => {
    if (value?.length < 2 && value?.length > 0) {
      setAddressObsOK("notOk");
    } else if (value?.length > 2) {
      setAddressObsOK("ok");
    } else {
      setAddressObsOK("vazio");
    }

    if (value?.length === 1) {
      setAddressObsError("Complemento deve ter pelo menos 2 caracteres");
    } else {
      setAddressObsError("");
    }
  };

  const handleInputAddressObs = useCallback(e => {
    let value = e.currentTarget.value;
    setAddressObs(value);
    handleValidationAddressObs(value);
  }, []);

  const handleValidationAddressNeighborHood = value => {
    value.length < 1
      ? setAddressNeighborhoodOK("notOk")
      : setAddressNeighborhoodOK("ok");
    if (value.length === 0) {
      setAddressNeighborhoodError("Campo obrigatório");
    } else {
      setAddressNeighborhoodError("");
    }
  };

  const handleInputAddressNeighborhood = useCallback(
    e => {
      if (addressNeighborhoodIsDisabled) return;

      let value = e.currentTarget.value;
      setAddressNeighborhood(value);
      handleValidationAddressNeighborHood(value);
    },
    [addressNeighborhoodIsDisabled]
  );

  const handleSetUfs = useCallback(async () => {
    try {
      const response = await (
        await axios.get(
          "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
        )
      ).data;
      const ufOpts = response.map(resp => ({
        value: resp.sigla,
        label: resp.nome
      }));
      setUfs(ufOpts);
    } catch (error) {
      console.error(error);
    }
  }, []);

  const handleSetCities = useCallback(async () => {
    try {
      const ufSelected = ufs.find(ufOpt => ufOpt.value === uf?.value);
      const response = await (
        await axios.get(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${ufSelected?.value}/municipios`
        )
      ).data;
      const ufOpts = response.map(resp => ({
        value: resp.nome,
        label: resp.nome
      }));
      setCities(ufOpts);
    } catch (error) {
      console.log(error);
    }
  }, [uf, ufs]);

  const handleSetUf = useCallback(
    e => {
      if (zipCode.length) return;

      setUf(e ? e : {});
      setUfStatus("");
    },
    [zipCode]
  );

  const handleSetCity = useCallback(
    e => {
      if (zipCode.length) return;

      setCity(e ? e : {});
      setCityStatus("");
    },
    [zipCode]
  );

  const handleValidationObs = value => {
    if (value?.length < 2 && value?.length > 0) {
      setObsOK("notOk");
    } else if (value?.length > 2) {
      setObsOK("ok");
    } else {
      setObsOK("vazio");
    }

    if (value?.length === 1) {
      setObsError("Observação deve ter pelo menos 2 caracteres");
    } else if (value?.length >= 29) {
      setObsError("Limite de caracteres atingído");
    } else {
      setObsError("");
    }
  };

  const handleInputObs = useCallback(e => {
    let value = e.currentTarget.value;

    handleValidationObs(value);
    if (value) {
      value = String(value).substring(0, 29);
    }

    setObs(value);
  }, []);

  const handleSelectSavedAddress = useCallback(
    async a => {
      setLoading(true);
      setFormState("update");

      setSelectedSaveAddress(a);

      setName(a.name);
      handleValidationName(a.name);

      const rawDocument = a.document.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
      const docHasLetters = /[A-Z]/.test(rawDocument);

      if (rawDocument.length <= 11 && !docHasLetters) {
        const cpf = rawDocument.replace(
          /^(\d{3})(\d{3})(\d{3})(\d{2})/,
          "$1.$2.$3-$4"
        );
        setCpf(cpf);
        handleValidationCPF(rawDocument);
      } else {
        const cnpj = rawDocument.replace(
          /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([0-9]{2})/,
          "$1.$2.$3/$4-$5"
        );
        setCpf(cnpj);
        handleValidationCNPJ(rawDocument);
      }

      const phoneFormatted =
        a.phone.length === 11
          ? a.phone.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3")
          : a.phone.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");

      setPhone(phoneFormatted);
      handleValidationPhone(phoneFormatted);

      setAddress(a.street);
      handleValidationAddress(a.street);

      setAddressNumber(a.number);
      handleValidationAddressNumber(a.number);

      setAddressObs(a.complement);
      handleValidationAddressObs(a.complement);

      setAddressNeighborhood(a.district);
      handleValidationAddressNeighborHood(a.district);

      setObs(a.observation);
      handleValidationObs(a.observation);

      const zipCode = a.zip.replace(/^(\d{5})(\d{3})/, "$1-$2");
      setZipCode(zipCode);
      handleValidationZipCode(zipCode, true);

      setUf({
        value: a.state,
        label: a.state
      });
      setUfStatus("");
      setCity({
        value: a.city,
        label: a.city
      });
      setCityStatus("");

      setSearching(false);
      setLoading(false);
    },
    [handleCepConsult]
  );

  const fieldsInFormIsAbleToSubmit = useCallback(
    (activedBySideEffect = false) => {
      let result = true;

      if (name === "") {
        if (!activedBySideEffect) {
          setNameOK("notOk");
          setNameError("Campo obrigatório");
          result = false;
        } else {
          return false;
        }
      }

      if (cpf === "") {
        if (!activedBySideEffect) {
          setCpfOK("notOk");
          setCpfError("Campo obrigatório");
          result = false;
        } else {
          return false;
        }
      }

      if (zipCode === "") {
        if (!activedBySideEffect) {
          setZipCodeOK("notOk");
          setZipCodeError("Campo obrigatório");
          result = false;
        } else {
          return false;
        }
      }

      if (zipCode.length && address === "") {
        if (!activedBySideEffect) {
          setAddressOK("notOk");
          setAddressError("Campo obrigatório");
          result = false;
        } else {
          return false;
        }
      }

      if (zipCode.length && addressNeighborhood === "") {
        if (!activedBySideEffect) {
          setAddressNeighborhoodOK("notOk");
          setAddressNeighborhoodError("Campo obrigatório");
          result = false;
        } else {
          return false;
        }
      }

      if (zipCode.length && uf === "") {
        if (!activedBySideEffect) {
          setUfStatus("notOk");
          result = false;
        } else {
          return false;
        }
      }

      if (zipCode.length && city === "") {
        if (!activedBySideEffect) {
          setCityStatus("notOk");
          result = false;
        } else {
          return false;
        }
      }

      if (
        nameOK === "notOk" ||
        cpfOK === "notOk" ||
        phoneOK === "notOk" ||
        zipCodeOK === "notOk" ||
        addressOK === "notOk" ||
        addressObsOK === "notOk" ||
        addressNeighborhoodOK === "notOk" ||
        uf === "" ||
        city === "" ||
        city.value === undefined ||
        uf.value === undefined
      ) {
        return false;
      }

      return result;
    },
    [
      address,
      addressNeighborhood,
      addressNeighborhoodOK,
      addressOK,
      addressObsOK,
      city,
      cpf,
      cpfOK,
      name,
      nameOK,
      phoneOK,
      uf,
      zipCode,
      zipCodeOK
    ]
  );

  const handleSubmit = useCallback(
    async e => {
      setLoading(true);
      e.preventDefault();

      const formCanSubmit = fieldsInFormIsAbleToSubmit();
      if (formCanSubmit === false) {
        Swal.fire({
          icon: "warning",
          title: "Validação",
          text: "É necessário que seja preenchidos todos os campos sinalizados."
        });
        setLoading(false);
        return;
      }

      const data = {
        name: name,
        document: cpf.replace(/[^A-Za-z0-9]/g, "").toUpperCase(),
        recipient: false,
        phone: phone.replace(/\D/g, "") || "",
        zip: zipCode.replace(/\D/g, ""),
        street: address,
        number: addressNumber || "",
        complement: addressObs || "",
        district: addressNeighborhood,
        state: uf?.value,
        city: city?.value,
        observation: obs,
        favorite: false
      };

      try {
        let createNewSenderBasedInStoragedUser = "";
        let infoSenderSavedInStorage =
          localStorage.getItem("brcom:send-location-resp") || "undefined";

        if (
          isFilledWithStorageData &&
          infoSenderSavedInStorage !== "undefined"
        ) {
          infoSenderSavedInStorage = JSON.parse(infoSenderSavedInStorage);
          if (
            infoSenderSavedInStorage?.name !== data.name ||
            infoSenderSavedInStorage?.zip !== data.zip ||
            infoSenderSavedInStorage?.street !== data.street ||
            infoSenderSavedInStorage?.district !== data.district
          ) {
            createNewSenderBasedInStoragedUser = "create";
          }
        }

        const methodAPI =
          createNewSenderBasedInStoragedUser === "create"
            ? "POST"
            : formState === "update"
              ? "PUT"
              : "POST";

        const urlAPI =
          createNewSenderBasedInStoragedUser === "create"
            ? `/addressbook`
            : formState === "update"
              ? `/addressbook/${selectedSavedAddress.id ||
              infoSenderSavedInStorage.id}`
              : `/addressbook`;

        const response = await api.makeHttpRequest({
          method: methodAPI,
          url: urlAPI,
          data
        });

        {
          window.localStorage.setItem(
            "brcom:send-location-resp",
            JSON.stringify(response)
          );

          console.log(
            "🚀 ~ file: index.jsx ~ line 834 ~ SendForm ~ isReverseLogistics",
            isReverseLogistics
          );
          let subroute;
          if (isReverseLogistics) {
            subroute = "reverse-destiny-form";
          } else {
            subroute = "normal-destiny-form";
          }

          history.push(
            `/nova-coleta/${subroute}${history?.location?.search &&
            history?.location?.search}`
          );
        }
      } catch (error) {
        console.log("🚀 ~ file: index.jsx:851 ~ SendForm ~ error", error);
        if (error?.response?.data?.message === "Validation failed") {
          Swal.fire({
            icon: "error",
            title: "Ocorreu um erro",
            text: "Verificar preenchimento dos campos."
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Ocorreu um erro",
            text: "Erro ao cadastrar remetente, tente novamente mais tarde."
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [
      fieldsInFormIsAbleToSubmit,
      searching,
      savedAddressOpts,
      name,
      cpf,
      phone,
      zipCode,
      address,
      addressNumber,
      addressObs,
      addressNeighborhood,
      uf.value,
      city.value,
      obs,
      isFilledWithStorageData,
      formState,
      selectedSavedAddress.id,
      api,
      query,
      history
    ]
  );

  const handleStorageSender = sender => {
    setLoading(true);
    setFormState("update");
    setIsFilledWithStorageData(true);

    setName(sender.name);
    handleValidationName(sender.name);

    const rawSenderDoc = sender.document.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
    const senderDocHasLetters = /[A-Z]/.test(rawSenderDoc);

    if (rawSenderDoc.length <= 11 && !senderDocHasLetters) {
      const cpf = rawSenderDoc.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})/,
        "$1.$2.$3-$4"
      );
      setCpf(cpf);
      handleValidationCPF(rawSenderDoc);
    } else {
      const cnpj = rawSenderDoc.replace(
        /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([0-9]{2})/,
        "$1.$2.$3/$4-$5"
      );
      setCpf(cnpj);
      handleValidationCNPJ(rawSenderDoc);
    }

    const phoneFormatted =
      sender.phone.length === 11
        ? sender.phone.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3")
        : sender.phone.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");

    setPhone(phoneFormatted);
    handleValidationPhone(phoneFormatted);

    setAddress(sender.street);
    handleValidationAddress(sender.street);

    setAddressNumber(sender.number);
    handleValidationAddressNumber(sender.number);

    setAddressObs(sender.complement);
    handleValidationAddressObs(sender.complement);

    setAddressNeighborhood(sender.district);
    handleValidationAddressNeighborHood(sender.district);

    setObs(sender.observation || "");
    handleValidationObs(sender.observation || "");

    const zipCode = sender.zip.replace(/^(\d{5})(\d{3})/, "$1-$2");
    setZipCode(zipCode);
    handleValidationZipCode(zipCode, true);

    setUf({
      value: sender.state,
      label: sender.state
    });
    setUfStatus("");
    setCity({
      value: sender.city,
      label: sender.city
    });
    setCityStatus("");

    setSearching(false);
    setLoading(false);
  };

  const handleDeleteAddress = async (id) => {
    try {

      if (!id) Swal.fire({
        title: "Erro!",
        text: "Tivemos problemas ao deletar o endereço selecionado.",
        icon: "error",
        confirmButtonColor: "#FF6B71"
      });

      setLoading(true);

      await api.makeHttpRequest({
        method: "DELETE",
        url: `addressbook/${id}/disable`,
      });

      setSaveAddress(prev => prev.filter(address => address.id !== id));

      Swal.fire({
        title: "Sucesso!",
        text: "Endereço deletado com sucesso.",
        icon: "success",
        confirmButtonColor: "#409e6a"
      });

    } catch (e) {
      Swal.fire({
        title: "Erro!",
        text: "Tivemos problemas ao deletar o endereço selecionado.",
        icon: "error",
        confirmButtonColor: "#FF6B71"
      });
    } finally {
      setLoading(false);
    }
  };

  const showModalToDeleteAddresses = (address) => {
    const zipCode = address?.zip?.length ? address?.zip?.replace(/^(\d{5})(\d{3})/, "$1-$2") : "--";
    const street = address?.street?.length ? address.street : "--"
    const number = address?.number?.toString()?.length ? address.number : "--"
    const district = address?.district?.length ? address.district : "--"
    const city = address?.city?.length ? address.city : "--"
    const state = address?.state?.length ? address.state : "--"

    Swal.fire({
      title: "Deseja remover o endereço?",
      html: `
        Deseja prosseguir com a remoção do endereço
        ${address?.name?.length ? (" <strong>" + address.name + "</strong>") : ""}?<br/>
        <br/> <strong> Dados: 
            ${street}, ${number}, ${district}, 
            ${city}/${state}. ${zipCode} </strong> <br/>
        <br/>Não será possível desfazer essa ação!
      `,
      icon: "warning",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      confirmButtonText: "Sim, remover endereço!"
    }).then(response => {
      if (response?.value) {
        handleDeleteAddress(address?.id);
      }
    });
  };

  useEffect(() => {
    window.setPageTitle("Remetente");

    const keyStorageSender = localStorage.getItem("brcom:send-location-resp");
    const paramsInUrl = query.get("shipping");


    if (keyStorageSender && keyStorageSender !== "undefined" && !paramsInUrl) {
      handleStorageSender(JSON.parse(keyStorageSender));
    }

    navigator.geolocation.getCurrentPosition(position => {
      setSendLocation({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });
    });
  }, []);

  useEffect(() => {
    return () => debouncedGetAddresses.cancel();
  }, [debouncedGetAddresses]);

  useEffect(() => {
    handleSetUfs();
  }, [handleSetUfs]);

  useEffect(() => {
    handleSetCities();
  }, [ufs, uf, handleSetCities]);

  useEffect(() => {
    if (sendLocation) {
      window.localStorage.setItem(
        "brcom:send-location",
        JSON.stringify(sendLocation)
      );
    }
  }, [sendLocation]);

  useEffect(() => {
    const shippingId = query.get("shipping");

    if (!shippingId) return;
    (async () => {
      try {
        setLoading(true);
        const response = await api.makeHttpRequest({
          method: "GET",
          url: `shipping/${shippingId}`
        });

        handleSelectSavedAddress(response.origin);
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Remetente salvo",
          text:
            "Houve um erro ao carregar as informações do remetente, tente novamente mais tarde."
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [query]);

  useEffect(() => {
    if (name === "" || !searching) {
      setSaveAddressOpts();
      return;
    }
    const data = savedAddress.filter(
      a => a.name.toLowerCase().search(name.toLowerCase()) >= 0
    );
    setSaveAddressOpts([...data]);
  }, [name, savedAddress, searching]);

  useEffect(() => {
    if (zipCodeOK.toLowerCase() === "notok") return;

    // 9 dígitos presente no CEP formatado 00000-000
    if (zipCode && zipCode.length === 9) {
      (async () => {
        try {
          setLoading(true);
          const response = await getMapsInformation(zipCode);

          if (!response) {
            return;
          }

          if (!response?.data?.results.length) {
            throw new Error("");
          }

          setSendLocation(response?.data?.results[0]?.geometry?.location);
        } catch (e) {
          Swal.fire({
            icon: "error",
            title: "Mapa",
            text:
              "Não foi possível carregar informações de localização desse endereço."
          });
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [zipCode, zipCodeOK]);

  useEffect(() => {
    const isAble = fieldsInFormIsAbleToSubmit(true);
    setFieldsAreAbleToSubmit(isAble);
  }, [fieldsInFormIsAbleToSubmit]);

  useEffect(() => {
    setButtonSubmitIsAble(fieldsAreAbleToSubmit);
  }, [fieldsAreAbleToSubmit]);

  return (
    <>
      <Loading loading={loading} />

      <main className={styles.main}>
        <div className={styles.container}>
          <div className={styles.title}>
            <h2>
              Dados do Remetente {isReverseLogistics && " (Envio Reverso)"}
            </h2>
          </div>
          <Steps step={step} total={totalSteps} />
          <form className={styles.form}>
            <div className={styles.formContent}>
              <div className={styles.inputsContainer}>
                <div className={styles.inputContainer}>
                  <div className={styles.input} role={nameOK}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Digite o nome do remetente"
                      onChange={e => handleInputName(e)}
                      value={name}
                      autoComplete="1234"
                    />
                    <AiOutlineCheck className={styles.check} role={nameOK} />
                    <BsExclamation className={styles.danger} role={nameOK} />
                  </div>
                  {nameError && <p className={styles.error}> {nameError} </p>}
                  {loadingAddresses &&
                    (
                      <div className={styles.optionsLoadingContainer}>
                        <div
                          className={styles.optionLoading}
                          onClick={() => setSearching(false)}
                        >
                          <Spinner animation="border" role="status" style={{ width: "20px", height: "20px" }}>
                            <span style={{ visibility: "hidden" }}>Loading...</span>
                          </Spinner>
                        </div>
                      </div>
                    )}
                  {!!savedAddressOpts && !loadingAddresses && (
                    <div className={styles.optionsContainer}>
                      {savedAddressOpts.length > 0
                        ? savedAddressOpts.map(a => (
                          <div
                            className={styles.option}
                            key={a.id}
                          >
                            <span
                              className={styles.optionText}
                              onClick={() => handleSelectSavedAddress(a)}
                            >
                              {a.name}
                            </span>

                            <FiTrash2
                              className={styles.optionAction}
                              onClick={() => showModalToDeleteAddresses(a)}
                            />
                          </div>
                        ))
                        : savedAddressOpts.some(
                          x => x.name.toLowerCase() === name.toLowerCase()
                        ) ? null : (
                          <div
                            className={styles.option}
                            onClick={() => setSearching(false)}
                          >
                            Criar: {name}
                          </div>
                        )}
                    </div>
                  )}
                </div>
                <div
                  className={`${styles.inputContainer} ${styles.inputContainerSmall}`}
                >
                  <div className={styles.input} role={cpfOK}>
                    <input
                      type="text"
                      name="cpf"
                      placeholder="CPF/CNPJ"
                      onChange={e => handleInputCpf(e)}
                      value={cpf}
                    />
                    <AiOutlineCheck className={styles.check} role={cpfOK} />
                    <BsExclamation className={styles.danger} role={cpfOK} />
                  </div>
                  {cpfError && <p className={styles.error}> {cpfError} </p>}
                </div>
                <div
                  className={`${styles.inputContainer} ${styles.inputContainerSmall}`}
                >
                  <div className={styles.input} role={phoneOK}>
                    <input
                      type="text"
                      name="phone"
                      placeholder="Telefone"
                      onChange={handleInputPhone}
                      value={phone}
                    />
                    <AiOutlineCheck className={styles.check} role={phoneOK} />
                    <BsExclamation className={styles.danger} role={phoneOK} />
                  </div>
                  {phoneError && <p className={styles.error}> {phoneError} </p>}
                </div>
                <div
                  className={`${styles.inputContainer} ${styles.inputContainerSmall} ${styles.inputContainerSmCep} `}
                >
                  <div className={styles.input} role={zipCodeOK}>
                    <input
                      type="text"
                      name="cep"
                      placeholder="CEP"
                      onChange={e => handleInputZipCode(e)}
                      value={zipCode}
                    />
                    <AiOutlineCheck className={styles.check} role={zipCodeOK} />
                    <BsExclamation className={styles.danger} role={zipCodeOK} />
                  </div>
                  {zipCodeError && (
                    <p className={styles.error}>{zipCodeError}</p>
                  )}
                  <a
                    href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.cep}
                  >
                    Não sei meu CEP
                  </a>
                </div>
                <div className={styles.mapContainerMobile}>
                  <GoogleMaps sendLocation={sendLocation} zoom={15} />
                </div>
                <div
                  className={`${styles.inputContainer} ${styles.inputContainerMd}`}
                  style={{ marginTop: "17px" }}
                >
                  <div
                    className={`${styles.input} ${addressIsDisabled ? styles.fieldDisabled : ""
                      }`}
                    role={addressOK}
                  >
                    <input
                      type="text"
                      name="address"
                      placeholder="Endereço"
                      onChange={e => handleInputAddress(e)}
                      value={address}
                    />
                    {addressError && (
                      <p className={styles.error}>{addressError}</p>
                    )}
                    <AiOutlineCheck className={styles.check} role={addressOK} />
                    <BsExclamation className={styles.danger} role={addressOK} />
                  </div>
                  {addressError && (
                    <p className={styles.error}>{addressError}</p>
                  )}
                </div>
                <div
                  className={`${styles.inputContainer} ${styles.inputContainerSm}`}
                >
                  <div
                    className={`${!!address?.length === false ? styles.fieldDisabled : ""
                      } ${styles.input}`}
                    role={addressNumberOK}
                  >
                    <input
                      type="text"
                      name="addressNumber"
                      placeholder="Número"
                      onChange={e => handleInputAddressNumber(e)}
                      value={addressNumber}
                    />
                    <AiOutlineCheck
                      className={styles.check}
                      role={addressNumberOK}
                    />
                    <BsExclamation
                      className={styles.danger}
                      role={addressNumberOK}
                    />
                  </div>
                  {addressNumberError && (
                    <p className={styles.error}>{addressNumberError}</p>
                  )}
                </div>
                <div
                  className={`${styles.inputContainer} ${styles.inputContainerSmall}`}
                >
                  <div
                    className={`${!!address?.length === false ? styles.fieldDisabled : ""
                      } ${styles.input}`}
                    role={addressObsOK}
                  >
                    <input
                      type="text"
                      name="addressObs"
                      placeholder="Complemento"
                      onChange={e => handleInputAddressObs(e)}
                      value={addressObs}
                    />
                    <AiOutlineCheck
                      className={styles.check}
                      role={addressObsOK}
                    />
                    <BsExclamation
                      className={styles.danger}
                      role={addressObsOK}
                    />
                  </div>
                  {addressObsError && (
                    <p className={styles.error}>{addressObsError}</p>
                  )}
                </div>
                <div
                  className={`${styles.inputContainer} ${styles.inputContainerSmall}`}
                >
                  <div
                    className={`${styles.input}  ${addressNeighborhoodIsDisabled ? styles.fieldDisabled : ""
                      }`}
                    role={addressNeighborhoodOK}
                  >
                    <input
                      type="text"
                      name="addressNeighborhood"
                      placeholder="Bairro"
                      onChange={e => handleInputAddressNeighborhood(e)}
                      value={addressNeighborhood}
                    />
                    <AiOutlineCheck
                      className={styles.check}
                      role={addressNeighborhoodOK}
                    />
                    <BsExclamation
                      className={styles.danger}
                      role={addressNeighborhoodOK}
                    />
                  </div>
                  {addressNeighborhoodError && (
                    <p className={styles.error}>{addressNeighborhoodError}</p>
                  )}
                </div>
                <div
                  className={`${styles.formSelect} ${ufStatus === "notOk"
                    ? styles.formSelectError
                    : ufStatus === "" && !!uf
                      ? styles.selectOk
                      : ""
                    }`}
                >
                  <Select
                    onChange={handleSetUf}
                    isDisabled={true}
                    defaultValue={uf}
                    value={uf}
                    options={ufs}
                    placeholder="Estado"
                    styles={selectStyle}
                    noOptionsMessage={({ inputValue }) =>
                      !inputValue && "Resultados não encontrados"
                    }
                  />

                  {ufStatus === "notOk" && (
                    <p className={styles.error}>Campo obrigatório</p>
                  )}
                </div>
                <div
                  className={`${styles.formSelect} ${cityStatus === "notOk"
                    ? styles.formSelectError
                    : cityStatus === "" && !!city
                      ? styles.selectOk
                      : ""
                    }`}
                >
                  <Select
                    onChange={handleSetCity}
                    isDisabled={true}
                    value={city}
                    defaultValue={city}
                    options={cities}
                    placeholder="Cidade"
                    styles={selectStyle}
                    noOptionsMessage={({ inputValue }) =>
                      !inputValue && "Resultados não encontrados"
                    }
                  />

                  {cityStatus === "notOk" && (
                    <p className={styles.error}>Campo obrigatório</p>
                  )}
                </div>
                <div className={`${styles.inputContainer}`}>
                  <p
                    className={`
                    ${styles.obsCounter}
                    ${obs.length >= 29
                        ? styles.obsCounterNotOk
                        : obs.length >= 15
                          ? styles.obsCounterWarn
                          : ""
                      }
                  `}
                  >
                    {obs.length}/29
                  </p>
                  <div
                    className={`${styles.input} ${styles.inputContainerObs}`}
                    role={obsOK}
                  >
                    <input
                      type="text"
                      name="obs"
                      placeholder="Observações"
                      onChange={e => handleInputObs(e)}
                      value={obs}
                    />
                    <AiOutlineCheck className={styles.check} role={obsOK} />
                    <BsExclamation className={styles.danger} role={obsOK} />
                  </div>
                  {obsError === "notOk" && (
                    <p className={styles.error}>{obsError}</p>
                  )}
                </div>
                <div
                  className={styles.errorContent}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p className={styles.error}>{obsError}</p>

                  <p
                    className={`
                    ${styles.obsCounter}
                    ${obs.length >= 29
                        ? styles.obsCounterNotOk
                        : obs.length >= 15
                          ? styles.obsCounterWarn
                          : ""
                      }
                  `}
                  >
                    {obs.length}/29 palavras
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.buttonsContainer}>
              <div
                className={`${styles.buttonContainer} ${!buttonSubmitIsAble ? styles.inactive : ""
                  }`}
              >
                <button type="submit" onClick={handleSubmit}>
                  Próximo passo
                  <PiCaretRightBold />
                </button>
              </div>
            </div>
          </form>
        </div>
        <div className={styles.mapContainer}>
          <GoogleMaps sendLocation={sendLocation} zoom={15} />
        </div>
      </main>
    </>
  );
};

export { SendForm };

